module.exports = __webpack_public_path__ + "static/media/maintenance-illustration.97ccc323.svg";